module.exports = __webpack_public_path__ + "img/4.fc85e329.png";